import React, { useState } from 'react';

/**
 * props:
 *  - typeOptions: [{value,label}] (선택적 검색조건 select)
 *  - extraFilter: { options:[{value,label}], value, onChange } (예: 회원상태 필터)
 *  - useDateRange: boolean
 *  - onSearch({ searchType, searchKeyword, searchStartDate, searchEndDate })
 */
export default function SearchBar({ typeOptions = [], extraFilter, useDateRange, onSearch, placeholder }) {
  const [searchType, setSearchType] = useState(typeOptions[0]?.value ?? '');
  const [keyword, setKeyword] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const submit = (e) => {
    e.preventDefault();
    onSearch({ searchType, searchKeyword: keyword, searchStartDate: startDate, searchEndDate: endDate, pageNo: 1 });
  };

  return (
    <form className="search-bar" onSubmit={submit}>
      {extraFilter && (
        <select className="select" value={extraFilter.value} onChange={(e) => extraFilter.onChange(e.target.value)}>
          {extraFilter.options.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      )}
      {typeOptions.length > 0 && (
        <select className="select" value={searchType} onChange={(e) => setSearchType(e.target.value)}>
          {typeOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      )}
      {useDateRange && (
        <>
          <input type="date" className="input" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
          <span className="text-secondary">~</span>
          <input type="date" className="input" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </>
      )}
      <input
        type="text"
        className="input keyword-input"
        placeholder={placeholder || '검색어를 입력하세요'}
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
      />
      <button type="submit" className="btn btn-secondary">검색</button>
    </form>
  );
}
